<div class="login-container">
    <div class="login-box p-5 d-flex align-items-center justify-content-center">
      <form [formGroup]="formLoginUser" class="d-flex">
          <img src="../../../../assets/logos/fgc-logo.svg" class="logo mb-3" alt="logo">
          <label class="label-input">Email</label>
            <input placeholder="Email" formControlName="document" name="user" />
          <label class="label-input">Senha</label>
            <input placeholder="Senha" type="password" formControlName="password" name="pass" />
          <small *ngIf="hasError" style="color: red">Usuário ou senha inválidos.</small>
          <p class="custom-link text-center mt-2 mb-1" (click)="lostPassword()">Primeiro acesso / Esqueci minha Senha</p>
          <button class="btn mt-4" (click)="login()">Acessar</button>
      </form>
    </div>
  </div>

  <div class="footer">
      <p>© 2022 - Portal FGC v1.0.0 -
          Fundo Garantidor de Créditos - FGC. Todos os direitos
          reservados.</p>
  </div>
